(ns minorodata.transform-environments.model
  (:require [mold.core :as m :refer-macros [defmodel]]
            [minorodata.users.model :refer [searchable-user]]))


(declare ->environment
         ->environments-panel
         ->transform-diff)

(defmodel environment
  {:environment-id  [::m/identity ::m/req ::m/string "Uniq id"]
   :client-id       [::m/string "Client id"]
   :created-by      {::m/type     ::m/ref
                     ::m/ref-type searchable-user
                     ::m/doc      "Related user"}
   :created-at      [::m/string "Created date"]
   :colour          [::m/string "Colour"]
   :name            [::m/string "Name"]})

(defmodel environments-panel
  {:environments {::m/type        ::m/ref
                  ::m/cardinality ::m/many
                  ::m/ref-type    environment
                  ::m/doc         "Link to environments related to current panel state"}

   :active-id           [::m/string ::m/nilable "Current environment id"]
   :modification-states [::m/map ::m/nilable "Modification states for groups"]
   :merge-transform-ids [::m/vector ::m/nilable "Transforms ids to merge"]}
  {:singleton true})

(defmodel transform-diff
  {:transform-id              [::m/identity ::m/req ::m/string "Transform id"]
   :group-id                  [::m/string "Group id"]
   :master-id                 [::m/string "Diff"]
   :transform-id-in-master    [::m/string "Transform id in master"]
   :master-transform-sql      [::m/string "Master transform sql"]
   :environment-transform-sql [::m/string "Environment transform sql"]
   :master-diverged?          [::m/bool "Master diverged?"]})

